<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Cliente' action='Listagem' btnLink='company/create' btnTxt='Incluir Cliente'/>

      <div class="wrapper wrapper-content animated fadeIn">

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <div class="row">
          <div class="col-lg-12">
            <div class="ibox float-e-margins">

              <div class="ibox-title">
                <h5>Clientes Cadastrados</h5>
              </div>

              <div class="ibox-content" v-if="isPermited">

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-12">
                      <list-filter v-on:filter="onFilter" :attributes="searchableFields"></list-filter>
                    </div>
                    <input-tag v-model="query.tags" :show-label="false" placeholder="Filtre por tag, separe com vírgula." class="col-lg-8" @input="onFilter(query.filter)"></input-tag>
                    <div class="col-lg-4 radio-group">
                      <label class="radio-inline">
                        <input type="radio" value="1" v-model="query.status" @change="onFilter(query.filter)">
                        <span class="label label-primary">Ativa</span>
                      </label>

                      <label class="radio-inline">
                        <input type="radio" value="2" v-model="query.status" @change="onFilter(query.filter)">
                        <span class="label label-warning">Pendente</span>
                      </label>

                      <label class="radio-inline">
                        <input type="radio" value="0" v-model="query.status" @change="onFilter(query.filter)">
                        <span class="label label-default">Inativa</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="panel-body">
                  <div class="panel-group">

                    <div class="panel panel-default" v-for="(cp, index) in companies" :key="cp.id">

                      <div class="panel-heading" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + cp.id" @click="loadUsers(cp); loadSensors(cp)">
                        <div class="row">
                          <div class="col-md-1">
                            <span class="label label-primary" v-if="cp.status == 1">Ativo</span>
                            <span class="label label-warning" v-if="cp.status == 2">Pendente</span>
                            <span class="label label-default" v-if="cp.status == 0">Inativo</span>
                          </div>
                          <div class="col-md-7 company-name">
                            <h5 class="panel-title"> {{ cp.name | textUpper }} </h5>
                          </div>
                          <div v-if="cp.fantasy" class="col-md-4"> {{ cp.fantasy | textUpper}} </div>
                        </div>

                      </div>

                      <div :id="'collapse'+ cp.id" class="panel-collapse collapse">
                        <div class="panel-body">

                          <table class="table">
                            <tbody>
                              <tr>
                                <td class="col-sm-5">
                                  <h3>{{ cp.name | textUpper }}</h3>
                                  <p>
                                    <span v-if="cp.type == 0">{{ cp.document | cnpj }}<br></span>
                                    <span v-if="cp.type == 1">{{ cp.document | cpf }}<br></span>
                                    <span v-if="cp.email"> {{ cp.email.replace(/,/, ', ') }} </span><br>
                                    <span v-if="cp.ie || cp.im"> <small >IE: {{ cp.ie }} * IM: {{ cp.im }}</small> <br></span>
                                    <abbr title="Phone">T:</abbr> {{ cp.phone | phone }}
                                  </p>
                                </td>
                                <td class="col-sm-4">
                                  <p v-if="cp.contact"> <strong>Contato:</strong><br>
                                    <span >{{ cp.contact }}</span><br>
                                    <span >{{ cp.contact_phone | phone }}</span><br>
                                  </p>
                                  <address>
                                    <strong>Endereço:</strong><br>
                                    <i class="fa fa-map-marker"></i> {{ cp.place }} Nº {{ cp.number }}<br>
                                    {{ cp.city }} - {{ cp.state }} <br> {{ cp.cep | cep }}
                                  </address>
                                </td>

                                <td class="col-sm-3 project">
                                  <button class="btn btn-success btn-outline btn-w-m" @click="editCompany(cp)"><i class="fa fa-pencil"></i> Editar </button>
                                  <button class="btn btn-success btn-w-m" @click="accessPage(cp)"><i class="fa fa-tags"></i> Produtos </button>
                                </td>

                              </tr>
                            </tbody>
                          </table>
                          <p v-for="act in cp.activities" :key="act.code">
                            <span class="label label-primary" v-if="act.main">&nbsp;&nbsp;Principal&nbsp;&nbsp;</span>
                            <span class="label label-default" v-else>Secundária</span>
                            <span v-if="act.code"> &nbsp; {{ act.code | cnaeFilter }}: {{ act.description }} </span>
                          </p>
                          <div class="users">
                            <h4>Usuários</h4>
                            <div v-if="Array.isArray(cp.users) && cp.users.length === 0">Nenhum usuário associado</div>
                            <div v-if="Array.isArray(cp.users) && cp.users.length > 0">
                              <div v-for="(user, idx) in cp.users" :key="user.public_key" class="image-box">
                                
                                <img :alt="user.name" class="img-circle" :src="user.img || '/static/img/profile.jpg'" data-toggle="dropdown">
                                
                                <ul class="dropdown-menu">
                                  <li><a href="#" class="font-bold">{{ user.name }}</a></li>
                                  <li class="divider"></li>
                                  <li><a href="#" @click.prevent="editUser(cp, user)">Visualizar</a></li>
                                  <li><a href="#" @click.prevent="deleteProccess(cp, user, idx, index)">Remover</a></li>
                                </ul>

                              </div>
                            </div>
                            <div v-if="cp.users === 'error'">Falha ao carregar usuários. <a href="#" @click.prevent="loadUsers(cp)">Tentar novamente</a>?</div>
                            <div v-if="loadingUsers" class="placeholder pulse-loading"></div>
                          </div>

                          <div class="sensors">
                            <h4>Sensores</h4>
                              <div v-if="Array.isArray(cp.sensors) && cp.sensors.length === 0">Nenhum sensor associado</div>
                           
                              <div v-if="Array.isArray(cp.sensors) && cp.sensors.length > 0" style="display: flex; flex-wrap: wrap;">
                                <span class="tag" v-for="sensor in cp.sensors" :key="sensor.public_key">{{ sensor.name }}</span>
                              </div>
                              <div v-if="cp.sensors === 'error'">Falha ao carregar sensores. <a href="#" @click.prevent="loadSensors(cp)">Tentar novamente</a>?</div>
                              <div v-if="loadingSensors" class="placeholder pulse-loading"></div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <button data-toggle="modal" data-target="#delete_modal" v-show="false" ref="deleteModal"> DELETE OCULTO </button>

                    <div class="modal inmodal" id="delete_modal" tabindex="-1" role="dialog"  aria-hidden="true">
                      <div class="modal-dialog">
                        <div class="modal-content animated fadeIn">
                          <div class="modal-header">

                            <button type="button" class="close" data-dismiss="modal" ref="btnClose">
                              <span aria-hidden="true">&times;</span><span class="sr-only"></span>
                            </button>

                            <i class="fa fa-trash modal-icon"></i>
                            <h4 class="modal-title">Atenção!</h4>
                          </div>

                          <div class="modal-body">
                            <p class="text-center">Deseja realmente Remover o Usuário <strong>"{{ removeTemp.name }}"</strong>? <br>
                              Após confirmação o mesmo não terá acesso a empresa!
                            </p>
                          </div>

                          <div class="modal-footer">
                            <button type="button" class="btn btn-white" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="removeUserFromCompany()">
                              Sim, remover!
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>

                    <pagination-links v-on:paginate="onPaginate" :more="more" :page="query.page" />

                  </div>
                </div>
              </div>

              <div class="ibox-content text-center" v-if="!isPermited || companies.length == 0">
                <h1>{{ emptyText }}</h1>
              </div>

            </div>
          </div>

        </div>

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'
  import InputTag from './InputTag'
  import Spinner from './layout/Spinner'
  import PaginationLinks from './PaginationLinks'
  import ListFilter from './ListFilter'

  import { mapGetters } from 'vuex'
  import { httpService } from '../providers/http-service'

  import { helper } from '../mixins/helper'
  import { toast } from '../mixins/toast'
  import { errorMessage } from '../mixins/error-message'
  import { permissions } from '../mixins/permissions'
  import { permissionManager } from '../mixins/permission-manager'

  export default {
    mixins: [ helper, toast, errorMessage, permissions, permissionManager ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, Spinner, PaginationLinks, ListFilter, InputTag },
    data () {
      return {
        more: false,
        showSpinner: false,
        removeTemp: { user_idx: null, comp_idx: null, user_pk: null, name: '', cmp: '' },
        emptyText: '',
        isPermited: true,
        companies: [],
        query: { filter: '', page: 0, limit: 10, status: '1', tags: [] },
        searchableFields: [
          { value: 'name', label: 'Razão Social' },
          { value: 'document', label: 'CNPJ' },
          { value: 'fantasy', label: 'Nome Fantasia' }
        ],
        loadingUsers: false,
        loadingSensors: false,
      }
    },

    methods: {
      ...mapGetters(['getCompany']),

      getcompaniesList() {
        this.checkPermissions('', '1f152b722d64ba573cd756fe5757ec80', 'Listar Clientes')
        .then((isPermited) => {
          if(isPermited) {
            this.showSpinner = true
            httpService.getCompanyCustomers(this.query).then((res) => {
              this.companies.push(...res.data.filter(cmp => cmp.public_key !== this.getCompany().public_key))
              if(this.companies.length == 0) { this.emptyText = 'Sem resultados para exibir' }
              this.showSpinner = false
              this.more = res.data.length === this.query.limit
            }).catch(err => this.showErrorMessage({ err: err }))
          } else {
            this.emptyText = 'Sem permissão para listar clientes'
            this.isPermited = isPermited
          }
        })
      },

      loadUsers(cmp) {
        cmp.users = cmp.users === 'error' ? undefined : cmp.users
        if(!Array.isArray(cmp.users)) {
          this.loadingUsers = true
          httpService.getCompanyUsers(cmp.public_key,{ filter: '', page: 0, limit: 100 }).then(res => {
            cmp.users = res.data
          }).catch(err => {
            cmp.users = 'error'
            this.showErrorMessage({ err: err })
          }).finally(() => {
            this.loadingUsers = false
            this.$forceUpdate()
          })
        }
      },

      loadSensors(cmp) {
        cmp.sensors = cmp.sensors === 'error' ? undefined : cmp.sensors
        if(!Array.isArray(cmp.sensors)) {
          this.loadingSensors = true
          httpService.getCompanySensors(cmp.id).then(res => {
            cmp.sensors = res.data
          }).catch(err => {
            cmp.sensors = 'error'
            this.showErrorMessage({ err: err })
          }).finally(() => {
            this.loadingSensors = false
            this.$forceUpdate()
          })
        }
      },

      editCompany(company) {
        this.checkPermissions(company.public_key, '5bc919ca057f99025eabfda5818b9741', 'alterar este cliente')
        .then((isPermited) => {
          if(isPermited) {
            company.activities = JSON.stringify(company.activities)
            this.$router.push({ path: '/company/create', query: company })
          }
        })
      },

      editUser(cp, user) {
        this.checkPermissions(cp.public_key, '11d0632099c633b1dd73b9bac676a621', 'Editar Usuário')
        .then((isPermited) => {
          if(isPermited){
            this.$router.push({ path: '/users/create', query: user })
          }
        })
      },

      removeUserFromCompany() {
        this.checkPermissions(this.removeTemp.cmp, 'f901d8efe84b23cb63ff741ba3b76943', 'Remover Usuário')
        .then((isPermited) => {
          const SSP_PORTAL = ['d300660e4320d8d5c8ecb48035b67815', 'dc162b04e8657157714050bce3908060']
          let promiseList = []
          
          SSP_PORTAL.forEach((prod) => {
            promiseList.push(httpService.removeUserAccess(this.removeTemp.cmp, prod, this.removeTemp.user_pk))
          })
          
          Promise.all(promiseList).then(() => {
            this.companies[this.removeTemp.comp_idx].users.splice(this.removeTemp.user_idx, 1)
            this.removeTemp = { user_idx: null, comp_idx: null, user_pk: null, name: '', cmp: '' }
            this.show_toast('success', 'Sucesso', 'Usuário removido com sucesso.')
          }).catch((err) => {
            this.show_toast('error', 'Erro', 'Falha ao remover usuário. "'+err.message+'"!')
          })
        })
      },

      deleteProccess(comp, user, idx, index) {
        this.removeTemp = { user_idx: idx, comp_idx: index, user_pk: user.public_key ,name: user.name, cmp: comp.public_key },
        this.$refs.deleteModal.click()
      },

      accessPage(company) {
        this.checkPermissions(company.public_key, '5bc919ca057f99025eabfda5818b9741', 'alterar este cliente')
        .then((isPermited) => {
          if(isPermited) {
            this.$router.push({ path: '/company/access', query: company })
          }
        })
      },

      onFilter(filter) {
        this.companies = []
        this.query.page = 0
        this.query.filter = filter
        this.getcompaniesList()
      },

      onPaginate(pagination) {
        this.query.page = pagination.page
        this.query.limit = pagination.limit
        this.getcompaniesList()
      }
    },
    mounted() {
      this.getcompaniesList()
    }
  }
</script>

<style scoped>
  .panel-body { padding-bottom: 0; }
  .company-name {  width: 50%; overflow: hidden; }
  .painel-title {  white-space: nowrap; text-overflow: ellipsis; display: block; }
  .panel-heading { cursor: pointer; }
  .table>tbody>tr>td { border-top: initial; }
  .users { margin: 15px 0; }
  .users .placeholder { height: 35px; width: 400px; }
  .image-box { height: 35px; cursor: pointer; position: relative; display: inline-block; margin: 0 4px; }
  .image-box img { height: 100%; }
  .image-box img:hover { opacity: 0.5; border: 2px solid #147ac7; }
  .tooltiptext {
    left: 37px;
    top: 4px;
    visibility: hidden;
    width: 140px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 3px;
    padding: 4px;
    position: absolute;
    z-index: 1;
    pointer-events: none;
  }
  .image-box:hover .tooltiptext { visibility: visible; }
  .sensors { margin: 0 0 10px 0; }
  .sensors .label { margin: 4px; font-size: 12px; white-space: initial;}
  .sensors .placeholder { height: 23px; width: 400px;}
  .radio-group { height: 49px; padding-top: 9px; }
  .tag {
    background-color: #1d84c6;
    color: #FFF;
    margin: 4px;
    padding: 4px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CompanyPage.vue